export default "__VITE_ASSET__8fa1bd76__"